import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { AddToQueueService } from 'src/app/service/add-to-queue.service';
import { GroupIStateService } from 'src/app/service/groupi-state.service';
import { PeriodsService } from 'src/app/service/periods.service';


@Component({
    selector: 'app-add-queue-dialog',
    templateUrl: './add-queue-dialog.component.html',
    styleUrls: ['./add-queue-dialog.component.scss'],
    standalone: false
})
export class AddQueueDialogComponent implements OnInit {
  heading: string;
  periodData = [];
  selected_period_id;
  selected_period_value
  tierData = [];
  selected_tier_id;
  selected_tier_value
  selectedPercentage: number;
  errormsg: string;

  gotResponse: boolean = false;
  successmsg;
  selected_tier_Position;
  userID;

  constructor(public dialogRef: MatDialogRef<AddQueueDialogComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly constants: Constants,
    private readonly periodsService : PeriodsService, private readonly addToQueue: AddToQueueService, private readonly ngxUiLoaderService : NgxUiLoaderService, private readonly groupIStateService : GroupIStateService) {

  }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    const userData = sessionStorage?.getItem('FGA');
    if (userData)
    {
      this.userID = JSON.parse(userData)?.user?.userPrincipalName;
      this.getPeriods();
    }else {
      this.showError("User ID Error");
    }
  }

  getPeriods() {

    const tempPeriod = JSON.parse(localStorage.getItem("period_data"))
    if (tempPeriod && tempPeriod.length > 0) {
      this.periodData = tempPeriod
      this.selected_period_id = this.periodData[0].periodId;
      this.selected_period_value = this.periodData.find(x => x.periodId == this.selected_period_id).period  // NOSONAR
      this.getTiers();
    } else {
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.periodsService.getPeriodsList().subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response.length > 0) {
            this.periodData = response
            this.selected_period_id = this.periodData[0].periodId;
            this.selected_period_value = this.periodData.find(x => x.periodId == this.selected_period_id).period  // NOSONAR
            this.getTiers();
          }
        }, _error => {
          this.errormsg = this.constants.APIErrorMessage
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        }
      );
    }
  }
  getTiers() {
    this.addToQueue.getTiersList(this.selected_period_id).subscribe(
      response => {
        this.tierData = response
        this.selected_tier_id = this.selected_tier_value = null;
        if (this.tierData.length > 0) {
          this.selected_tier_id = this.tierData[0].tierId;
          this.selected_tier_value = this.tierData.find(x => x.tierId == this.selected_tier_id).description  // NOSONAR
        }
      }, _error => {
        this.errormsg = this.constants.APIErrorMessage
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      }
    );
  }


  onNoClick(): void {
    this.dialogRef.close({
      event: 'NoEvent'
    });
  }
  close(): void {
    this.dialogRef.close(
      { event: 'CloseEvent' }
    );
  }
  public saveClick(): void {

    this.errormsg = ""
    if (this.isValueOk(this.userID)) {
      this.showError("User ID Error");
    } else if (this.isValueOk(this.selected_period_id)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.selected_tier_id)) {
      this.showError(this.constants.formInputError);
    } else if (isNaN(this.selectedPercentage)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.selectedPercentage)) {
      this.showError(this.constants.formInputError);
    } else if (Number(this.selectedPercentage) < 0 || Number(this.selectedPercentage) > 100) {
      this.errormsg = 'Percentage value should be in 0 - 100';
    } else {
      this.selected_tier_Position = this.tierData.find(x => x.tierId == this.selected_tier_id)?.tierPosition  // NOSONAR
      this.APICall();
    }

  }

  APICall() {
    this.errormsg = ""
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.addToQueue.saveAddToQueue(Number(this.selected_period_id), Number(this.selected_tier_Position), Number(this.selectedPercentage), this.userID).subscribe(
      response => {
        
        if (response == "Success") {  // NOSONAR
          this.dialogRef.close({
            event: "SaveEvent",
            data: "Success"
          });
        }
        else {    
          if(response != ""){  // NOSONAR
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          }
          this.showError(response)          
        }
        this.gotResponse = true;
        // this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        
      }, _error => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.showError(this.constants.APIErrorMessage);
      }
    )

    setTimeout(() => {
      if (!this.gotResponse) {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.dialogRef.close({
          event: "SaveEvent",
          data: "Success"
        });
        console.info("AddToQueue Response Timeout")
        this.gotResponse = false;
        
      }
    }, 10000);

  }

  showError(message) {
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = ""
    }, this.constants.notificationMessageTime);
  }

  isValueOk(param: any): boolean {
    if (param == undefined || param == null || param == "")  // NOSONAR
{
      return true;
}
    return false;
  }

}
